import i18nFactory from '@yandex-int/i18n';
import classNames from 'classnames';
import { CheckBox } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { OutdoorMapPlatform } from '../OutdoorMap/OutdoorMap';
import { OutdoorTextHighlight } from '../OutdoorTextHighlight/OutdoorTextHighlight';
import { listItem } from '../OutdoorVirtualList/OutdoorVirtualList';

import './OutdoorPlatform.css';
import * as keyset from './OutdoorPlatform.i18n';

const i18n = i18nFactory(keyset);

export interface OutdoorSearch {
    value: string;
    test: RegExp;
    match: RegExp;
}

export interface OutdoorPlatformProps {
    platform: OutdoorMapPlatform;
    imageLink: string;
    search: OutdoorSearch;
    highlighted?: boolean;
    onChange?: (platform: listItem) => void;
    onAddressClick?: (platform: listItem) => void;
    checked: boolean;
}

export class OutdoorPlatform extends React.Component<OutdoorPlatformProps> {
    private block = 'outdoor-platform';

    render() {
        const { platform, highlighted } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: this.block,
                    mods: {
                        highlighted: highlighted ? 'yes' : ''
                    }
                })}
            >
                <div>
                    <CheckBox
                        cls={classNames(
                            Bem.cls(this.block, 'check-box'),
                            Bem.cls('checkbox', '', { outdoor: 'yes' })
                        )}
                        theme={'normal'}
                        view={'default'}
                        size={'m'}
                        checked={this.props.checked}
                        onChange={this.onCheckBoxChange}
                    />
                    <div className={Bem.cls(this.block, 'container')}>
                        {this.HighLight(platform.caption, 'title')}
                        <div
                            className={Bem.cls(this.block, 'address')}
                            onClick={this.onAddressClick}
                        >
                            {this.HighLight(platform.address)}
                        </div>
                        <div className={Bem.cls(this.block, 'operator')}>
                            {this.HighLight(platform.provider)}
                        </div>
                        {platform.gid && (
                            <div className={Bem.cls(this.block, 'gid')}>
                                {this.HighLight(platform.gid)}
                            </div>
                        )}
                    </div>
                </div>
                {this.buildCreativeInfo()}
                {/*<div className={Bem.cls(this.block, 'image-container')}>*/}
                {/*<Image url={imageLink} cls={Bem.cls(this.block, 'image')} />*/}
                {/*</div>*/}
            </div>
        );
    }

    private buildCreativeInfo = () => {
        const { platform } = this.props;
        const info = [];

        if (platform.resolution) {
            info.push(`${platform.resolution} px`);
        }

        if (platform.duration) {
            info.push(`${platform.duration} ${i18n('seconds')}`);
        }

        return info.length ? (
            <div className={Bem.cls(this.block, 'creative-info')}>
                {info.join(', ')}
            </div>
        ) : (
            <></>
        );
    };

    private onAddressClick = () => {
        const { platform, onAddressClick } = this.props;

        if (onAddressClick) {
            onAddressClick(platform);
        }
    };

    private onCheckBoxChange = () => {
        const { platform, onChange } = this.props;

        if (onChange) {
            onChange(platform);
        }
    };

    private HighLight = (text: string, cls?: string) => {
        const searchValue = this.props.search.value;
        const clsString = cls ? Bem.cls(this.block, cls) : undefined;

        if (searchValue) {
            return (
                <OutdoorTextHighlight
                    cls={clsString}
                    text={text}
                    search={this.props.search.match}
                    searchValue={searchValue}
                />
            );
        } else {
            return <span className={clsString}>{text}</span>;
        }
    };
}
